import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import { PersonSearchService } from '../_services/person-search.service';
import * as _ from 'underscore';
import { LocalStorageService } from '../_services/local-storage.service';
import { SimilarCandidateService } from '../_services/similar-candidate.service';
import { GlobalService } from '../_services/global.service';

@Component({
  selector: 'app-person-search-candidate-slider',
  templateUrl: './person-search-candidate-slider.component.html',
  styleUrls: ['./person-search-candidate-slider.component.scss']
})
export class PersonSearchCandidateSliderComponent implements OnInit {
  public revealableInfo: { key: string, text: string, data?: string | string[], can_reveal: boolean, icon: string, is_revealed?: boolean }[] = [];
  clonedExperience: any;
  currentCompanyInformation: any = {};

  get hasRevealableInfo() {
    return this.revealableInfo.length > 0;
  }

  get hasWorkEmail() {
    return !!(this.data.work_email && this.data.work_email.length);
  }

  get hasPersonalEmail() {
    return !!(this.data.personal_email && this.data.personal_email.length);
  }

  constructor(
    private datePipe: DatePipe,
    private personSearchService: PersonSearchService,
    private localstorageservice: LocalStorageService,
    private similarCandidateService: SimilarCandidateService
  ) { }
  @Input() data: any = null;
  @Input() currentIndex: any;
  @Input() highlightkeywords;
  experience: any;
  formattedSkills: any;
  currentJobTitle: any;
  currentCompany: any;
  currentLocation: any;
  currentStartDate: any;
  currentTenure: any;
  totalTenure: any;
  uniqueProfiles: any = {};
  linkedin_url: any = null;
  facebook_url: any = null;
  twitter_url: any
  github_url: any
  stackoverflow_url: any
  behance_url: any
  dribbble_url: any
  medium_url: any
  quora_url: any

  profileTab: boolean = true
  contactTab: boolean = false
  similarTab: Boolean = false
  activityTab: Boolean = false


  @Output() childEvents = new EventEmitter<{ action: string, data: any, index: any }>();
  @Input() tabType;
  totalresultcount: any;
  similarcandidates: any[] = [];
  totalCandidatesCountLoading: Boolean = false;

  isProfileTabCalled: boolean = false;
  issimilartabshow: boolean = false;
  lastUpdatedExpDate: string;
  @Input() viewMoreSkills: boolean = false;
  
  ngOnInit(): void {
    this.saveProfileView();
    if (this.tabType == 'contactTab') {
      this.contactTab = true;
      this.profileTab = false
    } else if (this.tabType == 'activityTab') {
      this.activityTab = true;
      this.profileTab = false;
    }
    this.isProfileTabCalled = false;
    this.getsimilarcandidatesData()
    this.buildData();
  }

  /**
 * Handles all child events
 * @param action type of action
 * @param event Evenet
 */
  handleChildEvents(action: string, event?: Event) {
    this.childEvents.emit({ action: action, data: { ...this.data, selected: event ? (event.target as HTMLInputElement).checked : this.data.selected }, index: null })
  }


  closeNav() {
    this.handleChildEvents('closeNav')
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'block'

  }
  private pushRevealableInfo(key: string, text: string, data: string | string[], can_reveal: boolean = true, icon: string = 'fas fa-briefcase', is_revealed?: boolean) {
    if (data && Array.isArray(data) && data.length) {
      data = data.filter(d => d && d.length);
    }
    if (data && typeof data === 'string' && data.length) {
      data = [data];
    }
    data && data.length && this.revealableInfo.push({
      key,
      text,
      data,
      can_reveal,
      icon,
      is_revealed
    });
  }

  private getFormattedTenure(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (totalYears > 0 && totalMonths > 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'} ${totalMonths} Mths`;
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      return `${totalMonths} Mths`;
    } else {
      return '';
    }
  }

  openUrl(link, type) {
    if (!link || !type)
      return;
    if (link.startsWith("www.linkedin") || link.startsWith("www.facebook") || link.startsWith("www.twitter") || link.startsWith("www.github"))
      link = "https://" + link;
    else if (type == 'linkedin' && !(link.includes("https://www.linkedin") || link.includes("https://linkedin") || link.includes("https://in.linkedin") || link.includes("http://linkedin") || link.includes("http://www.linkedin")))
      link = "https://www." + link;
    else if (type == 'facebook' && !(link.includes("https://www.facebook") || link.includes("https://facebook") || link.includes("https://in.facebook") || link.includes("http://facebook") || link.includes("http://www.facebook")))
      link = "https://www." + link;
    else if (type == 'twitter' && !(link.includes("https://www.twitter") || link.includes("https://twitter") || link.includes("https://in.twitter") || link.includes("http://twitter") || link.includes("http://www.twitter")))
      link = "https://www." + link;
    else if (type == 'github' && !(link.includes("https://www.github") || link.includes("https://github") || link.includes("https://in.github") || link.includes("http://github") || link.includes("http://www.github")))
      link = "https://www." + link;
    else if (type == 'website') {
      link = "https://www." + link;
    }
    window.open(link, "_blank")
  }

  viewmoredetails(data, type) {
    if (type == 'viewmore') {
      document.getElementById(data + '_less').style.display = 'none'
      document.getElementById(data + '_more').style.display = 'block'
    } else {
      document.getElementById(data + '_less').style.display = 'block'
      document.getElementById(data + '_more').style.display = 'none'
    }
  }

  isBoolean(value: any) {
    if (typeof value == 'boolean' || value == 'true') {
      return true;
    }
    return false;
  }

  transform(value: string | string[]): string {
    if (!value) {
      return '';
    }

    if (Array.isArray(value)) {
      value = value[0] || '';
    }

    const regex = /(<.*?>)?([^<>]+)/g;
    const transformedValue = value.replace(regex, (match, htmlTag, text) => {
      if (text) {
        const transformedText = text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
        const result = htmlTag ? `${htmlTag}${transformedText}` : transformedText;
        return result;
      }
      return match;
    });

    return transformedValue;
  }

  checkIfProfessionalEmailAvailable(emails) {
    if (emails && emails.length) {
      return emails.filter(x => x.type == 'professional').length
    }
    return false
  }

  formatDate(dateString: string): string {
    if (dateString == null || dateString == 'null') {
      return '';
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      // If the date is not valid, or it's just a year (e.g., "2014")
      // then we return it as it is.
      return dateString;
    } else if (dateString && dateString.length === 4) {
      // If the date string contains only the year (e.g., "2014"),
      // we format it as "YYYY" (e.g., "2014")
      return this.datePipe.transform(date, 'yyyy');
    } else {
      // If it's a full date, we format it as "MMMM yyyy" (e.g., "January 2014")
      return this.datePipe.transform(date, 'MMMM yyyy');
    }
  }


  buildData() {
    this.currentLocation = this.data.location_name; //? this.data.location_name : this.data.location_names && this.data.location_names.length ? this.data.location_names[0] : null;
    this.isProfileTabCalled = true

    this.data.experience = this.data.experience.map(obj => {
      const startDate = moment(obj.start_date);
      const endDate = moment(obj.end_date || new Date());
      const totalTenure = endDate.diff(startDate, 'years', true);
      obj.totaltenure = this.getFormattedTenure(totalTenure);

      if (obj.is_primary === true || obj.is_primary === 'true') {
        this.currentJobTitle = obj?.title?.name;
        this.currentCompany = obj?.company?.name;
        this.currentTenure = obj?.totaltenure;
        this.currentStartDate = startDate;
        // if(this.currentLocation == null){
        //   this.currentLocation = obj.company.location && obj.company.location.name ? obj.company.location.name: null;
        // }
        obj.expsummary = this.data && this.data.highlight && this.data.highlight.job_summary ? this.data.highlight.job_summary[0] : obj.summary
      } else {
        obj.expsummary = obj.summary;

      }
      return obj;
    })

      const companyObjects = _.pluck(this.data.experience, 'company');
      const companyNames = _.unique(_.pluck(companyObjects, 'name'));
      const filteredCompanyNames = _.filter(companyNames, (name) => {
        return name !== null && name !== undefined && name !== '';
      });

      let nameData = {
        companynames: filteredCompanyNames
      }
      this.personSearchService.getCompanyLogo(nameData).subscribe((res: any) => {
        if(res && res.status == "success"){
          const resultName = res.message
          resultName.forEach(obj => {
            const matchingObj = this.data.experience.filter((item) => (item.company && item.company.name) === obj.key);
            if (matchingObj && matchingObj.length) {
              let companyLogo = obj.companylogo
              matchingObj.forEach(x => {
                x.companylogo = companyLogo;
              })

            }
          });

        }
    })

    let expdetails = _.sortBy(this.data.experience, "is_primary==true");
    if (expdetails != undefined) {
      this.data.experience = _.where(expdetails, { is_primary: true });
      this.data.experience = this.data.experience.concat(
        _.reject(expdetails, { is_primary: true })
      );
    } else {
      this.data.experience = _.sortBy(this.data.experience, "startdate");
      this.data.experience = this.data.experience.reverse();
    }

    this.clonedExperience = this.data.experience.filter(obj => obj.is_primary != true && obj.is_primary != 'true');

    // if(this.clonedExperience && this.clonedExperience.length){
    //   if(this.currentLocation == null){
    //     this.currentLocation = this.clonedExperience[0].company.location.name
    //   }
    // }

    if (this.clonedExperience && this.clonedExperience.length) {
      if (this.currentJobTitle == null) {
        this.currentJobTitle = this.clonedExperience[0].title.name;
      }
      if (this.currentCompany == null) {
        this.currentCompany = this.clonedExperience[0].company.name;
      }
      if (this.currentTenure == null) {
        this.currentTenure = this.clonedExperience[0].totaltenure;
      }


    }

    this.linkedin_url = this.data.linkedin_url

   // enter the revealable info here
    this.pushRevealableInfo('personal_email', 'Personal Email', this.data.personal_emails, true, 'fas fa-briefcase');
    this.pushRevealableInfo('work_email', 'Professional Email', this.data.work_email, true, 'fas fa-envelope');
    this.pushRevealableInfo('mobile_phone', 'Phone Number', this.data.mobile_phone, true, 'fas fa-phone');

    this.totalTenure = this.getFormattedTenure(this.data.totaltenure);
    this.formattedSkills = this.data.skills.map(skill => `${skill.replace(/<\/?em>/g, '')}`).map(skill => skill.replace(/\b\w/g, match => match.toUpperCase()));
    // console.log(this.formattedSkills, 'formattedSkillsformattedSkills')
    this.data.education = this.data.education.map(obj => {
      if (!(obj.degrees && obj.degrees.length)) {
        if (obj.majors && obj.majors.length) {
          obj.newField = obj.majors[0];
          return obj;
        }
        return obj;
      }

      if (obj.degrees && obj.degrees.length) {
        let degreeWords = obj.degrees[0].split(' ');
        if (degreeWords.length > 2) {
          obj.newField = obj.degrees[0];
        } else {
          let position = 0;
          for (let i = 1; i < obj.degrees.length; i++) {
            degreeWords = obj.degrees[i].split(' ');
            position = i;
            if (degreeWords.length > 2) {
              obj.newField = obj.degrees[i];
              return obj;
            }
          }
          if (obj.majors && obj.majors.length) {
            obj.newField = degreeWords[position] + ' in ' + obj.majors[0];
          }
        }
        if (!obj.newField) obj.newField = obj.degrees.toString().trim().replace(/'/g, "''");
        return obj;
      }
      return obj;
    });

    const lastSeenexp = _.sortBy(this.data.experience, "last_seen").reverse();
    this.lastUpdatedExpDate = GlobalService.getUpdateDates(lastSeenexp[0].last_seen).text;
  }

  onTabChange(tab) {
    this.viewMoreSkills = false;
    // const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    // //loadn[0].style.display = 'block'
    if (tab == 'profile') {
      this.profileTab = true
      this.contactTab = false
      this.similarTab = false
      this.activityTab = false;
      this.buildData();
    } else if (tab == 'contact') {
      this.profileTab = false
      this.contactTab = true
      this.similarTab = false
      this.activityTab = false;
      //   //loadn[0].style.display = 'none'
    }
    else if (tab == 'similarcandidates') {
      this.profileTab = false
      this.contactTab = false
      this.similarTab = true;
      this.activityTab = false;
    } else if (tab === 'activity') {
      this.profileTab = false
      this.contactTab = false
      this.similarTab = false;
      this.activityTab = true;

    }
    else {
      // add another condition if required
    }
  }


  eventHandler(event) {
    this.data = event.data;
    this.childEvents.emit({ action: 'append-data', data: event.data, index: this.currentIndex })

  }

  saveProfileView() {
    const data = {
      date: new Date().toISOString().slice(0, 10),
      elastic_id: this.data.idinindex

    }
    this.personSearchService.saveProfileView(data).subscribe((result: any) => {
      // this code is only used for tracking 
    });
  }
  getCompanyInfo(type: string, data: any, event) {
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'none'
   // this.currentCompanyInformation = {}
    let companyData = {}
    let pastCompanyData = data?.company
    if (!pastCompanyData?.website) {
      return;
    }

    if (type == 'past') {
      companyData = {
        companynames: [pastCompanyData?.name]
      }
    }

    this.personSearchService.getCompanyLogo(companyData).subscribe((res: any) => {
      if (res.status == 'success' && res.message) {
        let companyDetails = res.message[0]
        if (type == 'past') {
          this.currentCompanyInformation['name'] = companyDetails.name ? companyDetails.name : pastCompanyData.name
          this.currentCompanyInformation['industry'] = companyDetails?.industry ? companyDetails?.industry : pastCompanyData?.industry
          this.currentCompanyInformation['location'] = companyDetails?.location?.name ? companyDetails?.location?.name : pastCompanyData?.location
          this.currentCompanyInformation['size'] = companyDetails.size ? companyDetails.size : pastCompanyData?.size
          this.currentCompanyInformation['linkedin_url'] = companyDetails.linkedin_url ? companyDetails.linkedin_url : pastCompanyData.linkedin_url
          this.currentCompanyInformation['website'] = companyDetails.website ? companyDetails.website : pastCompanyData.website

          companyData = {
            companynames: [pastCompanyData?.name]
          }
        }
        this.currentCompanyInformation['companylogo'] = res.message[0].companylogo
        this.currentCompanyInformation['tags'] = res.message[0].tags
        this.currentCompanyInformation['id'] = res.message[0].id
        this.currentCompanyInformation['key_id'] = res.message[0].id  


        //loadn[0].style.display = 'block'
      }
    });


  }


  highlightInfo(data: string, type: 'current_jobtitle' | 'past_jobtitle' | 'location' | 'skill' | 'exp_summary' | 'currentjobtitle' | 'summary' | 'currentcompany' | 'pastcompany') {
    let keywords: any
    keywords = _.without(this.highlightkeywords, "AND","and","or","OR","not","NOT");
    if(data) {
     const dataForHighlight = data.trim().toLowerCase().replace(/<.*?>/g, '').replace(/'/g, "");

      let highlightedData = data;
      switch (type) {
        case 'current_jobtitle':
          {
            if(this.data && this.data?.highlight && this.data?.highlight['experience.title.name'] ) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound); 
             } if(this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound); 
             } if(this.data && this.data?.highlight && this.data?.highlight['job_title.keyword']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound); 
             } if(this.data && this.data?.highlight && this.data?.highlight['job_title']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound); 
             }
          }
          break; 
        case 'past_jobtitle':
          {
            if(this.data && this.data?.highlight && this.data?.highlight['experience.title.name'] ) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound); 
             } if(this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound); 
             } if(this.data && this.data?.highlight && this.data?.highlight['job_title.keyword']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound); 
             } if(this.data && this.data?.highlight && this.data?.highlight['job_title']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound); 
             }
          }
          break;
        case 'location':
          {
            if(this.data && this.data?.highlight && this.data?.highlight['location_name'] ) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['location_name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound); 
            } if(this.data && this.data?.highlight && this.data?.highlight['location_locality'] ) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['location_locality'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound); 
            } if(this.data && this.data?.highlight && this.data?.highlight['location_name.keyword'] ) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['location_name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound); 
            }
          }
          break;
        case 'skill':
          {
            if(this.data && this.data?.highlight && this.data?.highlight['skills'] ) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['skills'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound); 
            } if(this.data && this.data?.highlight && this.data?.highlight['skills.keyword'] ) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['skills.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound); 
            }
          }
          break;
          case 'exp_summary':
            {
              if(this.data && this.data?.highlight && this.data?.highlight['experience.summary'] ) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.summary'].find((summary: string) => summary.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound); 
               } if(this.data && this.data?.highlight && this.data?.highlight['summary']) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['summary'].find((summary: string) => summary.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound); 
               }
            }
            break;
          case 'currentjobtitle':
            {
              if(this.data && this.data?.highlight && this.data?.highlight['experience.title.name'] ) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound); 
               } if(this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword']) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound); 
               } if(this.data && this.data?.highlight && this.data?.highlight['job_title.keyword']) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound); 
               } if(this.data && this.data?.highlight && this.data?.highlight['job_title']) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound); 
               }
            }
            break;
          case 'summary':
            {
              if(this.data && this.data?.highlight && this.data?.highlight['experience.summary'] ) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.summary'].find((summary: string) => summary.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound); 
               } if(this.data && this.data?.highlight && this.data?.highlight['summary']) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['summary'].find((summary: string) => summary.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound); 
               }
            }
            break;
          case 'currentcompany':
            {
              if(this.data && this.data?.highlight && this.data?.highlight['job_company_name'] ) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_company_name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound); 
               } if(this.data && this.data?.highlight && this.data?.highlight['job_company_name.keyword']) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_company_name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound); 
               } if(this.data && this.data?.highlight && this.data?.highlight['experience.company.name']) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.company.name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound); 
               } if(this.data && this.data?.highlight && this.data?.highlight['experience.company.name.keyword']) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.company.name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound); 
               }
            }
            break;

          case 'pastcompany':
            {
              if(this.data && this.data?.highlight && this.data?.highlight['job_company_name'] ) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_company_name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound); 
               } if(this.data && this.data?.highlight && this.data?.highlight['job_company_name.keyword']) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_company_name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound); 
               } if(this.data && this.data?.highlight && this.data?.highlight['experience.company.name']) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.company.name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound); 
               } if(this.data && this.data?.highlight && this.data?.highlight['experience.company.name.keyword']) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.company.name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound); 
               } if(this.data && this.data?.highlight && this.data?.highlight['lastjob_company_name.keyword']) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['lastjob_company_name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').replace(/'/g, "").trim().toLowerCase() === dataForHighlight.replace(/'/g, ""));
                highlightFound && (highlightedData = highlightFound); 
               }
            }
            break;
        }

      return highlightedData;
  //  }
  }

    return data;
  }

  getsimilarcandidatesData() {
    this.issimilartabshow = false;
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'none'
    this.personSearchService.getdetailsfromlinkedin(this.data.linkedin_url).subscribe((res: any) => {
      if (res.status == "success") {
        if (res.data) {
          const pastindustries = _.pluck(res.data.experience, 'company')
          const schools = _.pluck(res.data.education, 'school')
          const locations = []
          res.data.location_locality && locations.push(res.data.location_locality);
          res.data.location_region && locations.push(res.data.location_region);
          res.data.location_country && locations.push(res.data.location_country);

          const totalTenure = res.data.totaltenure || 0;  
          const fromYrsOfExperience = (parseInt(totalTenure) - (parseInt(totalTenure) * 0.25));
          const toYrsOfExperinece = (parseInt(totalTenure) + (parseInt(totalTenure) * 0.25));

          const requestObject = {
            startindex: 0,
            resultsize: 10,
            searchviaboolean: true,
            booleanquery: "*",
            jobtitles: [],
            preferredskills: [],
            mandatoryskills: [],
            locations: [],
            companies: [],
            industries: [],
            exclusionlist: [],
            genders: [],
            seniority: [],
            graduationyear: [],
            schools: [],
            schooltypes: [],
            educationaldegrees: [],
            educationalmajors: [],
            candidateshavingemails: false,
            candidateshavingcontactnumbers: false,
            minexperience: null,
            maxexperience: null,
            minexperienceinccurrentcompany: null,
            zipcodes: [],
            companysizes: [],
            candidateshavingcontacts: false,
            workregions: [],
            workcountries: [],
            worklocalities: [],
            spokenlanguages: [],
            contacts: [],
            candidateshavingmobilenumber: false,
            candidateshavingpersonalemail: false,
            candidateshavingprofessionalemail: false,
            candidateshavingsocialprofiles: false,
            fromgraduationyears: [],
            tograduationyears: [],
            exclude_jobtitles: [],
            exclude_companies: [],
            exclude_locations: [],
            fromyearsofexperience: [],
            toyearsofexperience: [],
            likelytomovetype: [],
            salaries: [],
            salaryranges: [],
            continentstobeincluded: res.data.location_continent ? [res.data.location_continent]: [],
            similarcandidates_industries: res.data.job_company_industry ? [{ key: res.data.job_company_industry, isMandatory: true }] : [],
            similarcandidates_locations:  _.uniq(locations).map(l => ({ key: l, isMandatory: false })),
            similarcandidates_skills: res.data.skills ? res.data.skills.map(s => ({ key: s, isMandatory: false })) : [],
            similarcandidates_companysizes: res.data.job_company_size ? [{ key: res.data.job_company_size, isMandatory: false }] : [],
            similarcandidates_fromyearsofexperience: [fromYrsOfExperience],
            similarcandidates_toyearsofexperience: [toYrsOfExperinece],
            similarcandidates_totaltenure: res.data.totaltenure,
            similarcandidates_jobtitles: res.data.job_title ? [{ key: res.data.job_title, isMandatory: true }] : [],
            similarcandidates_companies: res.data.job_company_name ? [{ key: res.data.job_company_name, isMandatory: false }] : [],
            exclude_persons: [res.data.id],
            linkedinurl: this.data.linkedin_url,
            isUploadedFromResume: false,
            fullname: res.data.full_name,
            needcuratedtalentpooltags: true
            //  zone: this.localstorageservice.getItem('region')
          }

          if (this.similarCandidateService.isListingCalledFromSimilarCandidate) {
            delete requestObject.needcuratedtalentpooltags;
          }
          this.personSearchService.getPersonSearchRecommendCandidates(requestObject).subscribe(response => {
            if (response.status == "success") {

              this.totalresultcount = response.data.totalresultscount;
              this.similarcandidates = response.data.results;
              this.issimilartabshow = true
              // //loadn[0].style.display = 'block';
              // this.isProfileTabCalled = true;
            }
          })



        }
      }
    })
  }

  // not in an indian format
  formatNumberToIndianFormat(number) {
    if (number) {
      const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0
    }
  }

  ngOnDestroy() {
    this.eventHandler({ data: this.data })
  }

}
